export const LoadingSpinner: React.FC = () => {
  return (
    <div className="relative w-5 h-5">
      <div
        className="absolute inset-0 border-2 rounded-full outline-quaternary"
        style={{ borderColor: "#ddd" }}
      ></div>
      <div
        className="absolute inset-0 border-2 border-transparent rounded-full animate-spin"
        style={{ borderTopColor: "#121212" }}
      ></div>
    </div>
  );
};
